import React from "react";
import InputMask from "react-input-mask";
import { Typeahead } from "react-bootstrap-typeahead";
import { useState } from "react";
import { FieldHelper } from "../../../config/helpers/FieldHelper";
// import CurrencyFormat from "react-currency-format";

export default function Field({ type, options, keyOption, nameOption, value, onChange, name, title, mask, hint, disabled, placeholder, maxLenght }) {
    const [query, setQuery] = useState("");
    const [show, setShow] = useState(false);

    return (
        <div className="form-group">
            <span>{title}</span>
            {type == FieldHelper.FieldTypeObj.Select ?
                <select className="form-control" value={value} name={name} key={name} disabled={disabled} onChange={evt => onChange(evt)}>
                    <option selected={value == null ? true : false}>{title}</option>
                    {options && options.map(item => (
                        <option value={item[keyOption]}>{item[nameOption]}</option>
                    ))}
                </select>
                : ""}
            {type == FieldHelper.FieldTypeObj.Mask ?
                <InputMask
                    mask={mask}
                    type="text"
                    className="form-control"
                    name={name}
                    placeholder={title}
                    key={name}
                    value={value}
                    onChange={(event) => {
                        onChange({
                            target: {
                                name: name,
                                value: event.target.value,
                            },
                        });
                    }} />
                : ""}
            {/* {type == FieldHelper.FieldTypeObj.Currency ?
                <CurrencyFormat
                    className={`form-control`}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    allowNegative={false}
                    name={name}
                    value={value}
                    prefix={"R$"}
                    onValueChange={(values) => {
                        const { formattedValue, value } = values;
                        console.log("Dados", formattedValue, value);
                        onChange(
                            { target: { name: name, value: value } }
                        );
                    }}
                />
                : ""} */}
            {type == FieldHelper.FieldTypeObj.TypeAhead ?
                <Typeahead
                    options={options}
                    labelKey={(option) => `${option[nameOption]}`}
                    onSearch={(q) => setQuery(q)}
                    placeholder={title}
                    key={name}
                    onChange={(selected) => {
                        if (selected[0] != undefined || selected[0] != null) {
                            onChange({ target: { value: selected[0][keyOption], name } });
                        }
                    }}
                />
                : ""}
            {type == FieldHelper.FieldTypeObj.Number ?
                <input type="number" placeholder={placeholder} name={name} value={value} key={name} disabled={disabled} maxLength={maxLenght} className="form-control" onChange={evt => onChange(evt)} />
                : ""}
            {type == FieldHelper.FieldTypeObj.Time ?
                <input type="time" placeholder={placeholder} name={name} value={value} key={name} disabled={disabled} className="form-control" onChange={evt => onChange(evt)} />
                : ""}
            {type == FieldHelper.FieldTypeObj.Date ?
                <input type="date" placeholder={placeholder} name={name} value={value} key={name} disabled={disabled} className="form-control" onChange={evt => onChange(evt)} />
                : ""}
            {type == undefined || type == FieldHelper.FieldTypeObj.Text ?
                <input type="text" placeholder={placeholder} name={name} value={value} key={name} disabled={disabled} maxLength={maxLenght} className="form-control" onChange={evt => onChange(evt)} />
                : ""}
            {type == FieldHelper.FieldTypeObj.TextArea ?
                <textarea type="text" placeholder={placeholder} name={name} value={value} key={name} disabled={disabled} maxLength={maxLenght} className="form-control" onChange={evt => onChange(evt)} />
                : ""}
            {type == FieldHelper.FieldTypeObj.Password ?
                <div class="input-group">
                <input type={show ? "text" : "password"} className="form-control" placeholder={placeholder} name={name} value={value} key={name} disabled={disabled} maxLength={maxLenght} onChange={evt => onChange(evt)}/>
                <div class="input-group-append" style={{cursor: "pointer"}} onClick={() => setShow(!show)}>
                    <span class="input-group-text">
                        <i class={show ? "far fa-eye" : "far fa-eye-slash"}></i>
                    </span>
                </div>
            </div>
                : ""}
            {hint != undefined ?
                <small>{hint}</small>
                : ""}
        </div>
    )
}